import { useTranslation } from "@fanfanlo"

export enum AndroidPermissionStatus{
    granted = 'granted',
    denied = 'denied',
    shouldAskAgain = 'shouldAskAgain',
}
export interface IAndroidPermission{
    name:string
    status:AndroidPermissionStatusType
}

export interface IAndroidPermissions {
    [key:string]:IAndroidPermission
}
export type AndroidPermissionStatusType = AndroidPermissionStatus.granted | AndroidPermissionStatus.denied | AndroidPermissionStatus.shouldAskAgain

export const androidPermissions:IAndroidPermissions = {
    a11y:{
        name:"android.permission.ACCESS_NOTIFICATION_POLICY",
        status:AndroidPermissionStatus.shouldAskAgain,
    }
}

export function usePermissionStatus(status:AndroidPermissionStatus){
    // console.log('usePermissionStatus_fn22', status, useTranslation)
    const {t} = useTranslation('app-model/mc/android-permission/content') 
    return t(`androidPermission.${status}`)
}